<app-account-log
    [accounts]="accounts$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async">
</app-account-log>
